module.exports = __webpack_public_path__ + "img/Female_Posterior_PaperDoll.dadb8356.png";